import React from "react";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import {
    FootNote,
    SizeCell,
    SplitCaKingCell,
    SplitKingCell,
    sizeIcons,
} from "./_shared";

import styles from "../../../styles/composable/product-specifications.module.scss";

/**
 * Native port of ``cms/blocks/product-specifications/probreeze.html`` (#33410).
 * ``breeze-specifications`` wrapper; six size cells with ProBreeze weights.
 */
export const ProBreeze = (): React.JSX.Element => (
    <div
        className={concatClassNames([
            "breeze-specifications",
            styles.specifications,
        ])}
    >
        <SizeCell
            icon={sizeIcons.adaptTwinXl}
            heading="Twin Long"
            lines={['38" x 80"', "Single Mattress", "68-82 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptQueen}
            heading="Queen"
            lines={['60" x 80"', "Single Mattress", "108-136 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptKing}
            heading="King"
            lines={['76" x 80"', "Single Mattress", "138-175 lbs"]}
        />
        <SplitKingCell
            lines={['76" x 80"', "Double Mattress", "136-164 lbs"]}
        />
        <SizeCell
            icon={sizeIcons.adaptCaKing}
            heading="CA King"
            lines={['72" x 84"', "Single Mattress", "138-175 lbs"]}
        />
        <SplitCaKingCell
            lines={['72" x 84"', "Double Mattress", "136-164 lbs"]}
        />

        <FootNote />
    </div>
);
